import { render } from "./PlayerFormComponent.vue?vue&type=template&id=31f77231&scoped=true"
import script from "./PlayerFormComponent.vue?vue&type=script&lang=js"
export * from "./PlayerFormComponent.vue?vue&type=script&lang=js"

import "./PlayerFormComponent.vue?vue&type=style&index=0&id=31f77231&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f77231"]])

export default __exports__